module.exports = __webpack_public_path__ + "img/AF_GusmãoLabrunie_Icones_legal-marketing.8701b2a5.png";